import { render, staticRenderFns } from "./ownerDecision.vue?vue&type=template&id=acfaabf4&scoped=true"
import script from "./ownerDecision.vue?vue&type=script&lang=js"
export * from "./ownerDecision.vue?vue&type=script&lang=js"
import style0 from "./ownerDecision.vue?vue&type=style&index=0&id=acfaabf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfaabf4",
  null
  
)

export default component.exports